import { CurrentUserType } from "providers/types";
import { useTenant } from "modules/tenant/providers/tenant-provider";

export function useFeatures() {
  const { user: usert } = useTenant();
  //TODO: type the actual context instead
  const user = usert as CurrentUserType | null;

  const hasFeature = (feature: string): boolean => {
    if (!user) return false;
    const has = !!(
      user?.company?.company_configurations?.[0]?.ui_prefrences as Record<string, any>
    )?.[feature];
    return has;
  };

  return {
    hasFeature,
  };
}
